<template id="city-share-sheet">
  <f7-sheet
    class="share-sheet city-share-sheet"
    backdrop
    bottom
    :swipeToClose="true"
    :closeByBackdropClick="true"
    :closeByOutsideClick="true"
    :opened="props.shareSheetOpened"
    @sheet:closed="props.shareSheetOpened = false"
  >
    <f7-toolbar>
      <span class="notch"></span>
      <f7-link
        class="close-sheet-btn"
        @click="props.shareSheetOpened = false"
        icon-md="material:close"
      ></f7-link>
    </f7-toolbar>

    <f7-page-content>
      <!-- <f7-block-title large style="text-align: left; font-weight: 800; margin: 10px;">
      Compartí!
      </f7-block-title> -->
      <f7-block>
        <f7-row>
          <f7-col width="50" style="text-align: center">
            <f7-link
              class="external"
              :href="
                'https://api.whatsapp.com/send/?text=Esta%20carta%20es%20para%20ti!%20' +
                  $root.subdominioCiudad +
                  '.' +
                  $root.domainHostName
              "
              style="display: block"
            >
              <i class="fab fa-whatsapp share-sheet-icons"></i>
              <br /><br />
              <span>WhatsApp!</span>
            </f7-link>
          </f7-col>

          <f7-col width="50" style="text-align: center">
            <f7-link
              class="external"
              :href="
                'https://www.facebook.com/sharer/sharer.php?u=' +
                  $root.subdominioCiudad +
                  '.' +
                  $root.domainHostName
              "
              style="display: block"
            >
              <i class="fab fa-facebook-f share-sheet-icons"></i>
              <br /><br />
              <span>Facebook</span>
            </f7-link>
          </f7-col>
        </f7-row>
      </f7-block>
    </f7-page-content>
  </f7-sheet>
</template>

<script>
export default {
  props: {
    props: Object,
  },
  mounted: function() {
    const self = this;
  },
  methods: {},
};
</script>
